export const PlaceOrderGql = `
mutation PlaceOrder(
    $cart_id: String!
    $code: String!
    $brand_code: String!
    $stateData: String!
  ) {
    setPaymentMethodOnCart(
      input: {
        cart_id: $cart_id
        payment_method: {
            code: $code
            adyen_additional_data_hpp: {
                brand_code: $brand_code
                stateData: $stateData
            }
        }
      }
    ) {
      cart {
        selected_payment_method {
          code
          title
        }
      }
    }
    placeOrder(input: { cart_id: $cart_id }) {
      order {
        order_number
        cart_id
        adyen_payment_status {
          isFinal
          resultCode
          additionalData
          action
        }
      }
    }
  }
`;
